// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faqList_fdjFW{padding:30px 0 130px}.item_1LNwY{border-bottom:1px solid #dfdfdf}.faqList_fdjFW .question_3TLW9{position:relative;margin:0;padding:18px 45px 18px 0;line-height:1.3;color:#666;cursor:pointer;transition:color .3s}@media only screen and (min-width:1150px){.faqList_fdjFW .question_3TLW9{padding-right:55px}}.faqList_fdjFW .question_3TLW9:not(.questionAlwaysOpen_2bxUu):hover{color:#000}.faqList_fdjFW .question_3TLW9.questionAlwaysOpen_2bxUu{padding-right:0;cursor:default}.faqList_fdjFW .question_3TLW9.questionAlwaysOpen_2bxUu .iconPlus_90VUw{display:none}.iconPlus_90VUw{position:absolute;top:50%;right:1px;width:24px;height:24px;color:#6c9;transform:translateY(-50%);transition:color .3s}.answer_29Wmw{padding:0 0 15px;opacity:0;transform:translateY(-5px);transition:opacity .4s ease-in-out}.answer_29Wmw.visible_e3qPI{opacity:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faqList": "faqList_fdjFW",
	"item": "item_1LNwY",
	"question": "question_3TLW9",
	"questionAlwaysOpen": "questionAlwaysOpen_2bxUu",
	"iconPlus": "iconPlus_90VUw",
	"answer": "answer_29Wmw",
	"visible": "visible_e3qPI"
};
module.exports = ___CSS_LOADER_EXPORT___;
